document.addEventListener("DOMContentLoaded", function () {
  const isMobile = {
    Android: function () {
      return navigator.userAgent.match(/Android/i);
    },
    BlackBerry: function () {
      return navigator.userAgent.match(/BlackBerry/i);
    },
    iOS: function () {
      return navigator.userAgent.match(/iPhone|iPad|iPod/i);
    },
    Opera: function () {
      return navigator.userAgent.match(/Opera Mini/i);
    },
    Windows: function () {
      return (
        navigator.userAgent.match(/IEMobile/i) ||
        navigator.userAgent.match(/WPDesktop/i)
      );
    },
    any: function () {
      return (
        isMobile.Android() ||
        isMobile.BlackBerry() ||
        isMobile.iOS() ||
        isMobile.Opera() ||
        isMobile.Windows()
      );
    },
  };

  setTimeout(() => {
    if (window.innerWidth > 768) {
      document
        .querySelectorAll(".product-card--boost")
        .forEach(function (element) {
          const image_wrapper = element.querySelector(
            ".product-card__image-wrapper",
          );

          image_wrapper.addEventListener("mouseover", function (evt) {
            evt.currentTarget
              .closest(".product-card--boost")
              .classList.add("first-hover");
          });
          image_wrapper.addEventListener("mouseleave", function (evt) {
            evt.currentTarget
              .closest(".product-card--boost")
              .classList.remove("first-hover");
          });
        });
    }
  }, 5000);

  $(document).on("click", ".quick-add-mobile", function (event) {
    event.preventDefault();
    event.stopPropagation();

    // $(event.target).closest('.product-card__content').find('.myModal').css('display', 'block');
    // $(event.target).closest('.product-card__content').find('.myModal').addClass('open');
    $(".modal-general").addClass("open");
    $(".modal-general").css("display", "block");
    $(".modal-general").html(
      $(event.target).closest(".product-card__content").find(".myModal").html(),
    );
    $("body").css("overflow", "hidden");
  });

  $(document).on("click", ".myModal .close", function (event) {
    event.preventDefault();
    event.stopPropagation();

    $(".myModal").css("display", "none");
    $(event.target)
      .closest(".product-card__content")
      .find(".myModal")
      .removeClass("open");
    $("body").css("overflow", "auto");
  });

  $(document).on("click", ".product-card__sizes-item", function (event) {
    event.preventDefault();
    event.stopPropagation();
    let target =
      event.target.tagName == "LI" ? event.target : event.target.parentNode;

    if (target.dataset.productFastadd === "true") {
      let variantId = target.dataset.productVariant;

      const productCardInstance = window.initProductCards(
        document.querySelector(".product-card"),
      );

      productCardInstance.addItems([
        {
          id: variantId,
          quantity: 1,
        },
      ]);
    }

    setTimeout(function () {
      $(".myModal").css("display", "none");
      $(event.target)
        .closest(".product-card__content")
        .find(".myModal")
        .removeClass("open");
    }, 1500);
    $("body").css("overflow", "auto");
  });

  class PdpDrawer extends HTMLElement {
    constructor() {
      super();

      this.addEventListener("click", (evt) => {
        if (evt.target.classList.contains("pdp-drawer")) this.close();
      });

      this.querySelector(".pdp-drawer-close").addEventListener(
        "click",
        this.close.bind(this),
      );
    }

    close() {
      this.classList.remove("open");
      document.body.style.overflow = "";
    }
  }

  customElements.define("pdp-drawer", PdpDrawer);

  class ProductGallery extends HTMLElement {
    constructor() {
      super();

      this.initFancyBox();

      if (window.innerWidth < 769) {
        this.initSwiper();
      } else {
        this.repositionUspBar();
      }

      const self = this;

      window.addEventListener(
        "resize",
        this.debounce(function (e) {
          if (window.innerWidth < 769) {
            self.initSwiper();
            self.unpositionUspBar();
          } else {
            self.destroySwiper();
            self.repositionUspBar();
          }
        }),
      );
    }

    initFancyBox() {
      if (typeof Fancybox !== "undefined") {
        Fancybox.bind("[data-fancybox]", {
          mainClass: "reset-fancybox__track",
        });
      }
    }

    updatePaginationElement(current, total) {
      this.querySelector(".swiper-pagination").innerHTML =
        current + "/" + total;
    }

    initSwiper() {
      const self = this;
      //console.log("here self pdp", self)

      this.children[0].classList.add("swiper-wrapper");
      this.querySelectorAll(".product-media__container").forEach((slide) => {
        slide.classList.add("swiper-slide");
      });
      if (typeof Swiper === "undefined") {
        var link = document.createElement("link");
        link.type = "text/css";
        link.rel = "stylesheet";
        link.href =
          "https://cdn.jsdelivr.net/npm/swiper@10/swiper-bundle.min.css";
        document.head.appendChild(link);

        var script = document.createElement("script");
        script.type = "text/javascript";
        script.src =
          "https://cdn.jsdelivr.net/npm/swiper@10/swiper-bundle.min.js";
        script.onload = function () {
          fallback();
        };
        document.body.appendChild(script);
      } else {
        fallback();
      }
      function fallback() {
        self.swiper = new Swiper("product-gallery.swiper", {
          cssMode: true,
          watchSlidesProgress: true,
          centeredSlides: true,
          slidesPerView: 1,
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
          on: {
            afterInit: function () {
              self.updatePaginationElement(
                this.activeIndex + 1,
                this.slides.length,
              );
            },
            slideChange: function () {
              self.updatePaginationElement(
                this.activeIndex + 1,
                this.slides.length,
              );
            },
          },
        });
      }
    }

    destroySwiper() {
      if (this.swiper !== undefined) this.swiper.destroy(true, true);
      this.children[0].classList.remove("swiper-wrapper");
      this.querySelectorAll(".product-media__container").forEach((slide) => {
        slide.classList.remove("swiper-slide");
      });
    }

    debounce(func) {
      var timer;
      return function (event) {
        if (timer) clearTimeout(timer);
        timer = setTimeout(func, 100, event);
      };
    }

    repositionUspBar() {
      this.uspBar = document.querySelector(".usp-bar");
      if (this.uspBar) {
        this.uspBar.parentNode.removeChild(this.uspBar);

        const els = document.querySelectorAll(".product-media__container");

        if (els.length >= 4) {
          document
            .querySelector(".product-media__container:nth-child(4)")
            .after(this.uspBar);
        } else if (els.length <= 3) {
          document
            .querySelector(".product-media__container:nth-child(1)")
            .after(this.uspBar);
        }
      }
    }

    unpositionUspBar() {
      this.uspBar = document.querySelector(".usp-bar");
      this.uspBar.parentNode.removeChild(this.uspBar);
      document.querySelector(".pdp-variant-selector").after(this.uspBar);
    }
  }

  customElements.define("product-gallery", ProductGallery);

  class StoreAvailabilities extends PdpDrawer {
    constructor() {
      super();

      this.current_variant = null;
      this.renderGridForVariant();

      this.querySelector("select").addEventListener("change", (evt) => {
        this.renderGridForVariant();
      });
    }

    open() {
      this.classList.add("open");
      this.renderGridForVariant();
      document.body.style.overflow = "hidden";
    }

    setCurrentVariant(variant) {
      this.querySelector("select").value = variant.id;
      this.renderGridForVariant();
    }

    updateQueryString(key, value, url) {
      if (!url) url = window.location.href;

      let updated = "";
      var re = new RegExp("([?&])" + key + "=.*?(&|#|$)(.*)", "gi"),
        hash;

      if (re.test(url)) {
        if (typeof value !== "undefined" && value !== null) {
          updated = url.replace(re, "$1" + key + "=" + value + "$2$3");
        } else {
          hash = url.split("#");
          url = hash[0].replace(re, "$1$3").replace(/(&|\?)$/, "");
          if (typeof hash[1] !== "undefined" && hash[1] !== null) {
            url += "#" + hash[1];
          }
          updated = url;
        }
      } else {
        if (typeof value !== "undefined" && value !== null) {
          var separator = url.indexOf("?") !== -1 ? "&" : "?";
          hash = url.split("#");
          url = hash[0] + separator + key + "=" + value;
          if (typeof hash[1] !== "undefined" && hash[1] !== null) {
            url += "#" + hash[1];
          }
          updated = url;
        } else {
          updated = url;
        }
      }

      window.history.replaceState({ path: updated }, "", updated);
    }

    renderGridForVariant() {
      let output = "";
      let loadSociablekit = false;
      const selectedVariantId = document.getElementById("variantSelect").value;
      document.body.classList.add("loading-store-availabilities");
      this.querySelector("#find-a-store__spinner").classList.remove("hidden");
      this.updateQueryString("variant", selectedVariantId);

      fetch(`${window.location.pathname}?variant=${selectedVariantId}`)
        .then((r) => r.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(
            responseText,
            "text/html",
          );
          const scriptContent = html
            .getElementById("product_stores")
            .textContent.replaceAll("\n", "");
          const productStoresArray = JSON.parse(scriptContent);

          this.current_variant = productStoresArray.find(
            (variant) => variant.id === selectedVariantId,
          );

          if (this.current_variant.store_availabilities?.length) {
            this.current_variant.store_availabilities.forEach(
              (StoreAvailability) => {
                let opening_hours = "";
                if (StoreAvailability.google_business_profile_code) {
                  opening_hours = `<details class="store-availabilities__location--opening-hour">
                                    <summary role="button" aria-expanded="false" aria-controls="read-more">
                                        <strong>Opening Hours</strong>
                                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <g id="chevron-down">
                                                <path id="Vector" d="M9.38207 10.4612L13.1352 6.70814C13.3985 6.44477 13.3985 6.04971 13.1352 5.78633L12.2133 4.86452C11.95 4.60115 11.5549 4.60115 11.2915 4.86452L7.99935 8.09086L4.70717 4.86452C4.44379 4.60115 4.04873 4.60115 3.78536 4.86452L2.86355 5.78633C2.60017 6.04971 2.60017 6.44477 2.86355 6.70814L7.53844 11.383C7.80182 11.6464 8.19688 11.6464 8.46025 11.383L9.38207 10.4612Z" fill="black"/>
                                            </g>
                                        </svg>
                                    </summary>
                                    <div>
                                        <div class="sk-ww-google-business-profile" data-embed-id="${StoreAvailability.google_business_profile_code}"></div>
                                    </div>
                                </details>`;

                  loadSociablekit = true;
                } else if (StoreAvailability.opening_hours) {
                  opening_hours = `<details class="store-availabilities__location--opening-hour">
                                    <summary role="button" aria-expanded="false" aria-controls="read-more">
                                        <strong>Opening Hours</strong>
                                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <g id="chevron-down">
                                                <path id="Vector" d="M9.38207 10.4612L13.1352 6.70814C13.3985 6.44477 13.3985 6.04971 13.1352 5.78633L12.2133 4.86452C11.95 4.60115 11.5549 4.60115 11.2915 4.86452L7.99935 8.09086L4.70717 4.86452C4.44379 4.60115 4.04873 4.60115 3.78536 4.86452L2.86355 5.78633C2.60017 6.04971 2.60017 6.44477 2.86355 6.70814L7.53844 11.383C7.80182 11.6464 8.19688 11.6464 8.46025 11.383L9.38207 10.4612Z" fill="black"/>
                                            </g>
                                        </svg>
                                    </summary>
                                    <div>
                                        ${StoreAvailability.opening_hours}
                                    </div>
                                </details>`;
                }
                output += `
                        <div class="store-availabilities__location">
                            <div class="store-availabilities__location-top" style="background: linear-gradient(180deg, rgba(0, 0, 0, 0.00) 0%, rgba(0, 0, 0, 0.60) 67.19%), url('${StoreAvailability.location_image}'), lightgray 0.209px -16px / 105.343% 122.713% no-repeat;">
                                <div class="store-availabilities__location-top-location-name">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="17" viewBox="0 0 14 17" fill="none">
                                        <g clip-path="url(#clip0_696_23151)">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M8.558 15.0435C11.466 12.2005 13.75 9.9655 13.75 6.8335C13.75 5.10959 13.0652 3.45629 11.8462 2.2373C10.6272 1.01832 8.97391 0.333496 7.25 0.333496C5.52609 0.333496 3.87279 1.01832 2.65381 2.2373C1.43482 3.45629 0.75 5.10959 0.75 6.8335C0.75 9.9655 3.034 12.2005 5.942 15.0435C6.366 15.4595 6.804 15.8875 7.25 16.3335C7.696 15.8875 8.134 15.4595 8.558 15.0435ZM7.25 8.3335C7.91304 8.3335 8.54893 8.0701 9.01777 7.60126C9.48661 7.13242 9.75 6.49654 9.75 5.8335C9.75 5.17045 9.48661 4.53457 9.01777 4.06573C8.54893 3.59689 7.91304 3.3335 7.25 3.3335C6.58696 3.3335 5.95107 3.59689 5.48223 4.06573C5.01339 4.53457 4.75 5.17045 4.75 5.8335C4.75 6.49654 5.01339 7.13242 5.48223 7.60126C5.95107 8.0701 6.58696 8.3335 7.25 8.3335Z" fill="white"/>
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_696_23151">
                                                <rect width="13" height="16" fill="white" transform="translate(0.75 0.333496)"/>
                                            </clipPath>
                                        </defs>
                                    </svg>
                                    ${StoreAvailability.location_name}
                                </div>
                                <div>${StoreAvailability.location_address}</div>
                            </div>
                            <div class="store-availabilities__location-bottom">
                                <div>
                                    <div class="location-alert ${StoreAvailability.available === "true" ? "checked" : ""}">
                                        <svg class="cross-icon" xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                                            <path d="M1.75 1.3335L6.25 5.8335M10.75 10.3335L6.25 5.8335M6.25 5.8335L10.75 1.3335L1.75 10.3335" stroke="white" stroke-width="3"/>
                                        </svg>
                                        <svg class="tick-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="13" viewBox="0 0 16 13" fill="none">
                                            <path d="M1.75 4.8335L6.75 10.3335L14.25 1.3335" stroke="white" stroke-width="3"/>
                                        </svg>
                                        <span>In Store</span>
                                    </div>
                                    <div class="location-alert ${StoreAvailability.available === "true" ? "checked" : ""}">
                                        <svg class="cross-icon" xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                                            <path d="M1.75 1.3335L6.25 5.8335M10.75 10.3335L6.25 5.8335M6.25 5.8335L10.75 1.3335L1.75 10.3335" stroke="white" stroke-width="3"/>
                                        </svg>
                                        <svg class="tick-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="13" viewBox="0 0 16 13" fill="none">
                                            <path d="M1.75 4.8335L6.75 10.3335L14.25 1.3335" stroke="white" stroke-width="3"/>
                                        </svg>
                                        <span>Click & Collect</span>
                                    </div>
                                </div>
                                <div class="store-availabilities__location--phone-number">${StoreAvailability.contact_number}</div>
                                ${opening_hours}
                            </div>
                        </div>
                    `;
                    });
                } else {
                    output = "No store availability for this particular colour/size";
                }
                this.querySelector('.store-availabilities').innerHTML = output;
            })
            .catch((e) => {
                console.error(e);
                this.querySelector('.store-availabilities').innerHTML = "There is an error with fetching store availabilities. Please refresh the browser and try again.";
            })
            .finally(() => {
                document.body.classList.remove("loading-store-availabilities");
                this.querySelector('#find-a-store__spinner').classList.add("hidden");
                
                if (loadSociablekit) {
                    let script = document.createElement("script");
                    script.id = "google-business-profile-snippet";
                    script.src = "https://widgets.sociablekit.com/google-business-profile/widget.js";
                    document.head.appendChild(script);
                }
            });
        }
    }

    customElements.define('store-availabilities', StoreAvailabilities);

    class pdpVariantSelection extends HTMLElement {
        constructor() {
            super();

            const variant_buttons = this.querySelectorAll('input[type="radio"]');
            this.atcButton = this.querySelector('button.atc');
            this.bisButton = this.querySelector('.klaviyo-bis-trigger.klaviyo-bis-button ');
            this.formButtons = this.querySelector('.product-form__buttons');
            this.dynamicCheckout = this.querySelector('[data-pdp-dynamic-checkout]');
            this.oosbutton = this.querySelector('.klaviyo-bis-button.sale_product');
            this.itemsLeftText = this.querySelector('[data-items-left]');
            this.separatorText = this.querySelector('[data-items-left-separator]');
            this.atcText = this.querySelector('[data-add-to-cart-text]');
            this.atcLabel = this.dataset.atcLabel || 'Add to Cart';
            this.preorderLabel = this.dataset.preorderLabel || '';
            this.bisInfo = this.querySelector('.waitlist-info');
            this.bisInfo_sale_product = this.querySelector('.waitlist-info.sale_product');
            variant_buttons.forEach(button => {
                button.addEventListener('change', this.handleVariantChange.bind(this));
            });
            this.current_variant = null;
            this.variants = this.getVariantData();
            this.product_data =this.getProduct();

            if (this.product_data.gift_card){
                this.atcButton.style.display = "block";
                this.atcButton.classList.add('active');
                this.setDynamicCheckoutVisibility(true);
                this.itemsLeftText.innerText = ``
                this.separatorText.innerText = ``
                this.atcText.innerText = this.atcLabel
            }
            this.setupShopPayGrow();
            const sizeGuideButtons = document.querySelectorAll('.size-guide-trigger');
            sizeGuideButtons.forEach((element) => {
                element.addEventListener('click', (e) => {
                    e.preventDefault();
                    document.querySelector('.size-guide-drawer').classList.add('open');
                    document.body.style.overflow = 'hidden';
                });
            });

            this.findInStoreButton = this.querySelector('.find-in-store-btn');
            this.findInStore = document.querySelector('store-availabilities');
            if(this.findInStoreButton){
                this.findInStoreButton.addEventListener('click', () => this.findInStore.open());
            }
           

            this.form = this.querySelector('.shopify-product-form');
            this.hidden_form_element = this.querySelector('.shopify-product-form input[type=hidden][name="id"]');

            this.form.addEventListener('submit', this.handleATC.bind(this));

            this.checkedButton = false;

            variant_buttons.forEach(x => x.checked ? this.checkedButton = true : null);

            if(variant_buttons.length == 1 && !this.checkedButton) {
                document.querySelector(`label[for="${variant_buttons[0].id}"]`).click();
                this.current_variant = variant_buttons[0].value;
            }else if(this.checkedButton) {
                this.current_variant = this.querySelector('input[type="radio"]:checked').value;
                this.handleVariantChange();
            }
        }
        
        renderPrice(currentVariantId) {
            fetch(`${this.dataset.productUrl}?variant=${currentVariantId}&section_id=${this.dataset.section}`)
                .then((response) => response.text())
                .then((responseText) => {
                    const id = `price-${this.dataset.section}`;
                    const html = new DOMParser().parseFromString(responseText, 'text/html')
                    const destination = document.getElementById(id);
                    const source = html.getElementById(id);
                    
                    if (source && destination) destination.innerHTML = source.innerHTML;
                });
        }

        handleVariantChange(evt) {
            const button = evt?.target;
            this.current_variant = button?.value || this.current_variant;
            this.hidden_form_element.value = this.current_variant;

            const variant = this.variants.find(variant => variant.id == this.current_variant);
            this.findInStore.setCurrentVariant(variant);
            this.renderPrice(this.current_variant);
            
            if(!variant.available) {
                if(variant.compare_at_price == null || variant.compare_at_price == 0){
                    this.bisButton.classList.add('show');
                    this.oosbutton.classList.remove('show');
                    this.bisInfo.classList.add('show');
                    if(this.bisInfo_sale_product)this.bisInfo_sale_product.classList.remove('show');
                   
                }else{
                    this.oosbutton.classList.add('show');
                    this.bisButton.classList.remove('show');
                    this.bisInfo.classList.remove('show');
                    if(this.bisInfo_sale_product)this.bisInfo_sale_product.classList.add('show');
                }
                
                this.atcButton.style.display = "none";
                this.atcButton.classList.remove('active');
                this.setDynamicCheckoutVisibility(false);
            } else {
                this.oosbutton.classList.remove('show');
                this.bisButton.classList.remove('show');
                this.bisInfo.classList.remove('show');
                this.bisInfo_sale_product.classList.remove('show');
                this.atcButton.style.display = "block";
                this.atcButton.classList.add('active');
                this.setDynamicCheckoutVisibility(true);
                const itemsLeft = window.variant_inventory[variant.id];
                if (itemsLeft == null || itemsLeft > 5 || itemsLeft < 1) {
                    this.itemsLeftText.innerText = ``
                    this.separatorText.innerText = ``
                } else {
                    this.itemsLeftText.innerText = `${itemsLeft} left`
                    this.separatorText.innerText = `-`
                }
                this.atcText.innerText = this.isPreorder(itemsLeft) ? this.preorderLabel : this.atcLabel;
                if (this.product_data.gift_card){
                    this.itemsLeftText.innerText = ``
                    this.separatorText.innerText = ``
                    this.atcText.innerText = this.atcLabel
                }
            }
            this.updateURL();
            this.updateWishlistButton();
        }

        isPreorder(itemsLeft) {
            return Boolean(this.preorderLabel) && itemsLeft != null && itemsLeft < 1;
        }

        setDynamicCheckoutVisibility(isVisible) {
            if (!this.dynamicCheckout) return;
            this.dynamicCheckout.hidden = !isVisible;
            if (isVisible && window.Shopify?.PaymentButton) {
                window.Shopify.PaymentButton.init();
            }
            if (isVisible) {
                this.setupShopPayGrow();
            }
        }

        setupShopPayGrow() {
            const root = this.dynamicCheckout;
            if (!root) return;

            const bindGrow = () => {
                const paymentButton = root.querySelector('.shopify-payment-button');
                if (!paymentButton) return false;

                const moreOptions = paymentButton.querySelector('.shopify-payment-button__more-options');
                if (moreOptions && moreOptions.parentElement !== root) {
                    root.appendChild(moreOptions);
                }

                let growWrap = paymentButton.querySelector('.pdp-shop-pay-grow');
                if (!growWrap) {
                    const buttonEl = paymentButton.querySelector(
                        '.shopify-payment-button__button, shopify-accelerated-checkout'
                    );
                    if (!buttonEl) return false;

                    growWrap = document.createElement('div');
                    growWrap.className = 'pdp-shop-pay-grow';
                    buttonEl.parentNode.insertBefore(growWrap, buttonEl);
                    growWrap.appendChild(buttonEl);
                }

                if (growWrap.dataset.growBound) return true;
                growWrap.dataset.growBound = 'true';

                // Branded Shop Pay use iframe — parent :hover die. Track pointer vs button box.
                // Last move inside box stay hovered while cursor over iframe (no move events).
                window.addEventListener('pointermove', (event) => {
                    if (root.hidden) {
                        growWrap.classList.remove('is-hovered');
                        return;
                    }
                    const rect = growWrap.getBoundingClientRect();
                    const over =
                        event.clientX >= rect.left &&
                        event.clientX <= rect.right &&
                        event.clientY >= rect.top &&
                        event.clientY <= rect.bottom;
                    growWrap.classList.toggle('is-hovered', over);
                }, { passive: true });

                return true;
            };

            if (bindGrow()) return;

            const observer = new MutationObserver(() => {
                if (bindGrow()) observer.disconnect();
            });
            observer.observe(root, { childList: true, subtree: true });
            setTimeout(() => observer.disconnect(), 5000);
        }

        updateWishlistButton() {
            const wishlistButton =
                document.querySelector('.pdp-right wishlist-button-pdp.pdp-wishlist-header') ||
                this.querySelector('wishlist-button-pdp');
        
            if (wishlistButton && window.FishAPI) {
                wishlistButton.dataset.isAdded = [...window.FishAPI.app.allWishlistItems].some(item => String(item) === String(this.current_variant))
                wishlistButton.dataset.preselectedId = this.current_variant;
            }
        }

        getVariantData() {
            this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
            return this.variantData;
        }
        getProduct(){
            this.product_data = this.product_data || JSON.parse(this.querySelector('[type="product/json"]').textContent);
            return this.product_data;
        }

        updateURL() {
            if (!this.current_variant) return;

            const currentParams = new URLSearchParams(window.location.search);
            currentParams.set('variant', this.current_variant);

            const queryString = currentParams.toString();
            window.history.replaceState({}, '', `${this.dataset.url}${queryString ? '?' + queryString : ''}`);
        }

        handleATC(evt) {
            const submitter = evt.submitter;
            if (submitter?.closest?.('.shopify-payment-button') || submitter?.getAttribute?.('name') === 'checkout') {
                return;
            }
            evt.preventDefault();
            Object(window.addToCartSubmit)(evt);
           
            // nostojs(api => { 
            //     api.defaultSession()
            //       .reportAddToCart(this.current_variant, 'element')
            //       .update()
            //   });
        }

    }

    customElements.define('pdp-variant-select', pdpVariantSelection);

    class SizeGuideTable extends HTMLTableElement {
        constructor() {
            super();
            
            this.querySelector('input')?.addEventListener('change', this.toggleMeasurement.bind(this));
        }

        toggleMeasurement() {
           
            this.querySelectorAll('td').forEach(cell => {
                if(cell.dataset.cm && cell.dataset.in) {
                   
                    if(String(cell.innerText) == String(cell.dataset.cm)) {
                        cell.innerText = cell.dataset.in;
                    } else {
                        cell.innerText = cell.dataset.cm;
                    }
                }
            })
        }
    }

    customElements.define('size-guide-table', SizeGuideTable, { extends: "table" });
    var button_zendesk = document.querySelector('[data-testid="launcher"]')
    if (button_zendesk){
        button_zendesk.addEventListener('click', () => {
            zE.activate();
        })
    }

  if (document.querySelector(".pdp-as-you-see") && isMobile.any()) {
    const pdpIns = document.querySelector(".pdp-as-you-see");
    pdpIns
      .querySelector(".pdp-as-you-see-images-wrapper")
      .classList.add("swiper-wrapper");
    pdpIns
      .querySelectorAll(".pdp-as-you-see-images-wrapper img")
      .forEach((slide) => {
        slide.classList.add("swiper-slide");
      });
    if (typeof Swiper === "undefined") {
      var link = document.createElement("link");
      link.type = "text/css";
      link.rel = "stylesheet";
      link.href =
        "https://cdn.jsdelivr.net/npm/swiper@10/swiper-bundle.min.css";
      document.head.appendChild(link);

      var script = document.createElement("script");
      script.type = "text/javascript";
      script.src =
        "https://cdn.jsdelivr.net/npm/swiper@10/swiper-bundle.min.js";
      script.onload = function () {
        fallbackIns();
      };
      document.body.appendChild(script);
    } else {
      fallbackIns();
    }
    function fallbackIns() {
      const swiper = new Swiper(".pdp-as-you-see-images", {
        slidesPerView: 1.2,
        navigation: {
          nextEl: ".slider__arrow--next",
          prevEl: ".slider__arrow--prev",
        },
      });
    }
  }
  var qa_tab = document.querySelector(
    ".ugc-storefront-widgets-tabs-container.yotpo-main-widget-tabs .ugc-storefront-widgets-tabs-container__tab:nth-of-type(2n).selected",
  );
  var reviews_tab = document.querySelector(
    ".ugc-storefront-widgets-tabs-container.yotpo-main-widget-tabs .ugc-storefront-widgets-tabs-container__tab:first-of-type.selected",
  );
  var reviewButtons = document.querySelector(".reviews-widget__buttons");
  if (qa_tab) {
    qa_tab.addEventListener("click", function (e) {
      reviewButtons.classList.add("hidden");
    });
  }
  if (reviews_tab) {
    reviews_tab.addEventListener("click", function (e) {
      reviewButtons.classList.remove("hidden");
    });
  }

  const giftCardSelect = document.querySelector(".egift-card__form-select");

  if (giftCardSelect) {
    giftCardSelect.addEventListener("change", function () {
      const selectedVariantId = this.value;
      const correspondingRadioInput = document.getElementById(
        "variant-" + selectedVariantId,
      );

      if (correspondingRadioInput) {
        correspondingRadioInput.click(); // Simulate a click on the radio input
      }
    });
  }
});
